/**
 * Global.js
 *
 * Global theme interactions. Codekit app is used for compiling
 */
import { googleTranslate } from "./_translate";
import { FlexibleContent } from "./_flexible-content";
import { ExternalLinks } from "./_external-links";
import { SiteSearch } from "./_site-search";
import { Alerts } from "./_alerts";
import { get, includes, last } from "lodash-es";
import "../vendor/magnific-popup";
import "../vendor/matchMedia";
import "../vendor/jquery.cycle2";
import "../vendor/jquery.cycle2.carousel";
import "../vendor/jquery.touchSwipe";
const $ = window.jQuery;
import cookie from "./_cookies";

class Coastal1_Theme {
  // Initialize
  constructor() {
    this.videoPlaying = false;
    this.tabs();
    this.maps();
    this.login();
    this.accessibility();
    this.gformsDebug();
    this.slideshow();
    this.eventTracking();
    this.formTracking();
    this.sessionTracking();
    this.tables();
    this.highContrast();
    new SiteSearch();
    new Alerts();
    googleTranslate();
    new FlexibleContent();
    new ExternalLinks();
    this.hashRefs();
  }

  hashRefs() {
    const $loggedIn = $("body.logged-in");
    if (!$loggedIn.length) return;

    const $hashRefs = $("[data-hash-ref]");
    if (!$hashRefs.length) return;

    $hashRefs.each(function (index, el) {
      const id = $(el).attr("id");
      $(el).prepend(`<span class="hash-ref-identifier">#${id}</span>`);
    });
  }

  slugify(string) {
    return string
      .toLowerCase()
      .replace(/[^\w ]+/g, "")
      .replace(/ +/g, "-");
  }

  highContrast() {
    const $button = $('button[data-high-contrast="toggle"]');
    if (!$button.length) return;

    const active = cookie.get("high-contrast");
    if (active) {
      $("body").addClass("high-contrast");
    }

    $button.on("click", (event) => {
      const active = cookie.get("high-contrast");
      if (active) {
        cookie.remove("high-contrast");
        $("body").removeClass("high-contrast");
      } else {
        cookie.set("high-contrast", "active");
        $("body").addClass("high-contrast");
      }
    });
  }

  tables() {
    // Rowspans
    const $rowspan = $("td.td-product[rowspan]");
    if ($rowspan.length) {
      $rowspan.each(function () {
        const rows = parseFloat($(this).attr("rowspan"));
        if (rows <= 1) return;

        let $parent = $(this).parent();
        for (let i = 0; i < rows - 1; i++) {
          $parent = $parent.addClass("product-rowspan");
          $parent = $parent.next();
        }
      });

      $("td.td-product").each(function () {
        const html = $(this).html();
        $(this).parent("tr").before(`<tr class="tr-product"><td colspan="3">${html}</td></tr>`);
      });
    }

    // Overflow
    const $accordionTables = $(".accordion__content > table");
    if ($accordionTables.length) {
      $accordionTables.wrap(`<div class="accordion-table" />`);
    }
  }

  // Logging
  log(label, data) {
    console.log("%c " + label + " ", "background-color:#0000ff; color:white; font-weight:bold");
    console.log("%c " + JSON.stringify(data) + " ", "color:#0000ff; background:#fff; font-weight:bold");
  }

  // Session tracking
  sessionTracking() {
    let userId = cookie.get("coastal1__user-id");
    if (!userId) {
      userId = Date.now().toString(36) + Math.random().toString(36).substr(2);
      cookie.set("coastal1__user-id", userId);
    }

    // GTM dataLayer Push
    const data = {
      event: "Identify User",
      user_id: userId,
    };
    window.dataLayer.push(data);
  }

  // Track event
  //
  // Category is pushed verbatim. GTM triggers match on the exact category
  // string ("Phone Called", not "phone_called"), and the [data-event-click]
  // attributes in PHP templates already push unmodified values.
  trackEvent(category, action, label) {
    const data = {
      event: "Track Event",
      category: category,
      action: action,
      label: label || window.location.pathname + window.location.hash,
    };
    this.log("Tracked Event", data);
    window.dataLayer.push(data);
  }

  // Track a click that navigates away
  //
  // Lets modified clicks (new tab, new window, middle click) through untouched,
  // otherwise holds the navigation briefly so tags using an image pixel have
  // time to fire before the page unloads.
  trackNavigation(selector, resolve) {
    $(selector)
      .filter(":not([data-event-click])")
      .on("click", (event) => {
        const $link = $(event.currentTarget);
        const href = $link.attr("href");
        const resolved = resolve($link, href) || {};

        if (! resolved.category) {
          return;
        }

        this.trackEvent(resolved.category, resolved.action, resolved.label);

        // Modified clicks and new-tab links keep their native behavior
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.which > 1 || $link.attr("target") === "_blank") {
          return;
        }

        event.preventDefault();
        setTimeout(() => {
          window.location.href = href;
        }, 300);
      });
  }

  // Gravity Forms submissions are tracked entirely in lib/gforms.php, so that
  // they report without depending on this bundle being rebuilt.

  // Event tracking
  //
  // [data-event-click="{ "event": "Track Event", category: '', action: '', label: '', value: 1 }"]
  eventTracking() {
    // Apply Online Links
    $('a[href="https://coastal1.mymortgage-online.com/loan-app/?siteId=4143219744&workFlowId=188634"]').attr("target", "_blank").attr("rel", "noopener");
    $('a[href="https://coastal1.mymortgage-online.com/loan-app/?siteId=4143219744&workFlowId=188634"]:not([data-event-click])').each((index, element) => {
      const $this = $(element);
      const data = { event: "Track Event", category: "Apply Now" };

      // Where was the link that was clicked?
      if ($this.parents("header.site-header").length > 0) {
        data.action = "Mortgage Apply Online";
        data.label = "main-menu";
      } else {
        const title = $("head > title").text().replace(" - Coastal1 Credit Union", "");
        data.action = title;
        data.label = "unknown-link";
      }

      const json = JSON.stringify(data);

      $this.attr("data-event-click", `${json}`);
    });

    // Dynamic click tracking
    $("[data-event-click]").on("click", (event) => {
      const data = $(event.currentTarget).data("event-click");
      this.log("Tracked Event", data);
      window.dataLayer.push(data);
    });

    // Contact
    this.trackNavigation('a[href^="tel:"]', ($link, href) => ({
      category: "Phone Called",
      action: href.replace("tel:+1-", "").replace("tel:", ""),
    }));

    this.trackNavigation('a[href^="mailto:"]', ($link, href) => ({
      category: "Email Clicked",
      action: href.replace("mailto:", ""),
    }));

    // Deposit account applications
    this.trackNavigation('a[href^="https://forms.fivision.com"]', ($link) => {
      const $td = $link.parent("td");
      const $th = $td.closest("table").find("th").eq($td.index());
      const $productName = $td.find("h3.flat");
      let action = $productName.length ? $productName.text() : $th.text();

      // Additional conditions for /personal/savings-account/ layout
      if (! action) {
        action = $link.parent("p").prevAll("h3").first().text();
      }

      return { category: "Account Application Started", action: action || "Unknown Product" };
    });

    // Mortgage applications
    this.trackNavigation('a.btn[href*="/mortgage/apply-online/"]', ($link) => ({
      category: "Apply Now",
      action: $link.parent("p").prevAll("h3").first().text() || document.title,
    }));

    // Credit card applications
    this.trackNavigation('a[href*="mycardapply.com"], a[href*="creditcardlearnmore.com"]', ($link) => ({
      category: "Credit Card Application Started",
      action: $link.text().trim() || document.title,
    }));

    // Online banking enrollment
    this.trackNavigation('a[href*="AutoEnrollment"], a[href*="enroll.html"]', ($link) => ({
      category: "Online Banking Enrollment",
      action: $link.text().trim() || "Enroll",
    }));

    // Overdraft coverage enrollment
    this.trackNavigation('a[href*="extendcoverage.com"]', ($link) => ({
      category: "Overdraft Enrollment Started",
      action: $link.text().trim() || "Online Consent Form",
    }));

    // Loan payments
    this.trackNavigation('a[href*="baconpay.com"]', ($link) => ({
      category: "Loan Payment Started",
      action: $link.text().trim() || "Loan Payment",
    }));

    // Wealth management advisor handoff
    this.trackNavigation('a[href*="ameripriseadvisors.com"]', ($link) => ({
      category: "Wealth Management Contact",
      action: $link.closest(".wealth-manager, article, li, div").find("h2, h3, h4").first().text().trim() || $link.text().trim(),
    }));

    // Mobile app downloads
    this.trackNavigation('a[href*="itunes.apple.com"], a[href*="apps.apple.com"], a[href*="play.google.com"]', ($link, href) => ({
      category: "Mobile App Download",
      action: href.indexOf("play.google.com") > -1 ? "Android" : "iOS",
    }));

    // PDF downloads
    this.trackNavigation('a[href$=".pdf"]', ($link, href) => ({
      category: "PDF Download",
      action: last(href.split("/")),
    }));

    // Link security
    $(window).on("load", () => {
      $('a[target="_blank"]:not("[rel=noopener]")').attr("rel", "noopener");

      // Test for tab nabbing links
      setTimeout(() => {
        const $errors = $(`a[target="_blank"]:not([rel*=noopener])`);
        if ($errors.length) {
          console.fail(`Tab nabbing links detected.`);
        } else {
          console.log(`No tab nabbing links detected.`);
        }
      });
    });
  }

  // Hero slider
  slideshow() {
    // Existence check
    const $slider = $(".home-banner__slides");
    if (!$slider.length) return;

    const $slides = $(".home-banner__slides__item");
    if ($slides.length <= 1) return;

    $slider.attr("role", "region").attr("aria-label", "carousel");

    // Cycle2 slider
    $slider.cycle({
      fx: "fade",
      delay: 3000,
      timeout: 8000,
      speed: 800,
      log: false,
      manualSpeed: 700,
      prev: ".home-banner__slides__prev",
      next: ".home-banner__slides__next",
      slides: "> .home-banner__slides__item",
    });

    // Pause on slide when video is played, continue when it's paused or finishes
    const $iframe = $slider.find("iframe");
    if ($iframe.length) {
      const player = new Vimeo.Player($iframe);

      player.on("play", function () {
        console.log("Slider stopped while video is playing.");
        $slider.cycle("stop");
      });

      player.on("ended", function (event, player, $element) {
        console.log("Slider resumed when video has ended.");
        setTimeout(() => {
          $slider.cycle("next");
        }, 4000);
      });

      $slider.on("cycle-after", function (event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
        if ($(outgoingSlideEl).hasClass("home-banner__slides__item--video")) {
          console.log("Video paused when outgoing slide leaves view.");
          player.pause();
        }
      });

      // Before slide change
      $slider.on("cycle-update-view", (event, optionHash, slideOptionsHash, currentSlideEl) => {
        const $current = $(currentSlideEl);
        let totalHeight = 0;
        $current.children().each(function () {
          totalHeight += $(this).outerHeight(true);
        });
        $slider.height(totalHeight);

        if (!$current.find("iframe").length && player.playing) {
          player.pause();
        }
      });
    }

    // Touch event support
    $("> .home-banner__slides__item", $slider).swipe({
      swipeLeft: function (event, direction, distance, duration, fingerCount, fingerData) {
        $slider.cycle("next");
      },
      swipeRight: function (event, direction, distance, duration, fingerCount, fingerData) {
        $slider.cycle("prev");
      },
    });

    // Pause when content is hovered over
    $slider
      .on("mouseenter", (e) => {
        e.stopPropagation();
        $slider.cycle("pause");
      })
      .on("mouseleave", (e) => {
        e.stopPropagation();
        if (!$slider.find(".cycle-slide-active").hasClass("home-banner__slides__item--video")) {
          $slider.cycle("resume");
        }
      });
  }

  // Gravity forms debug helpers
  gformsDebug() {
    // Debug mode only
    if (!includes(location.search, "?debug")) return;

    // Must have mortgage inquiry form
    var $form = $("form#gform_2");
    if (!$form.length) return;

    // Testing input values
    var input = {
      input_5: "$416,000.00",
      input_7: "Purchase",
      input_8: "$615,000.00",
      "input_10.1": "1 Main St",
      "input_10.3": "Pawtucket",
      "input_10.4": "Rhode Island",
      "input_10.5": "02860",
      input_9: "Primary Residence",
      "input_13.3": "Kevin",
      "input_13.6": "Leary",
      input_14: "test@coastal1.org",
      input_15: "(781) 000-0000",
      "input_16.1": "50 Main St",
      "input_16.3": "Pawtucket",
      "input_16.4": "Rhode Island",
      "input_16.5": "02860",
      "input_16.6": "United States",
    };

    // Pre-populates form with input
    $form.find("input, select").each(function () {
      var name = $(this).attr("name");
      var val = get(input, name, false);
      if (!val) return;
      $(this).val(val);
    });

    console.warn("Form pre-populated with debug input for testing purposes.");
  }

  // Accessibility enhancements
  accessibility() {
    // Aria labels for <img> links
    const visaLinks = $('a[href^="https://usa.visa.com"]');
    if (visaLinks.length) {
      visaLinks.attr("aria-label", "Link to external website: usa.visa.com");
    }

    // Aria labels for honeypot spam fields
    const honeypotFields = $(".gform_validation_container");
    if (honeypotFields.length) {
      honeypotFields.attr("aria-hidden", "true");
    }

    // Footer
    const $footer_h2 = $(".site-footer__h2");
    if ($footer_h2.length) {
      $footer_h2.each((index, element) => {
        const $this = $(element);
        const text = $this.text();
        const slug = this.slugify(text);

        $this.attr("id", `footer-menu-${slug}`);
        $this.next("ul.sub-menu").attr("aria-labelledby", `footer-menu-${slug}`);
      });
    }
  }

  // Login form
  login() {
    $("form#forgot-password").hide();

    // Validate field
    var validateField = function (name, $form) {
      var $field = $('input[name="' + name + '"]', $form);
      var val = $field.val();

      if (!val) {
        $field.addClass("has-error").attr("aria-invalid", true).next(".validation-error").fadeIn();
        return false;
      } else {
        $field.removeClass("has-error").attr("aria-invalid", false).next(".validation-error").hide();
        return true;
      }
    };

    // Login submit
    $("form#login").on("submit", (e) => {
      const $this = $(e.currentTarget);
      var user_id = validateField("user_id", $this);
      var password = validateField("password", $this);
      if (!user_id || !password) {
        e.preventDefault();
      }
      this.trackEvent("Banking Login", user_id);
    });
  }

  // Leaflet maps
  maps() {
    const $map = $("#map");
    if (!$map.length) return;

    const pin = L.layerGroup();
    const lat = window.branch.lat;
    const lng = window.branch.lng;
    const branch = $(".site-hero h1").text();
    const address = decodeURIComponent(window.branch.address).replace(/\+/gi, " ");
    const dialog = `<h6>${branch}</h6><p>${address}</p>`;
    const icon = L.icon({
      iconUrl: "/wp-content/themes/coastal1/assets/icons/favicon-32x32.png",
      iconSize: [32, 32], // size of the icon
      iconAnchor: [20, 10], // point of the icon which will correspond to marker's location
      popupAnchor: [0, -10], // point from which the popup should open relative to the iconAnchor
    });

    L.marker([lat, lng], { icon: icon }).bindPopup(dialog).addTo(pin);

    const cartoDB = L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: "abcd",
      maxZoom: 19,
    });

    const map = L.map("map", {
      center: [lat, lng],
      zoom: 10,
      zoomControl: false,
      trackResize: false,
      boxZoom: false,
      doubleClickZoom: false,
      dragging: false,
      keyboard: false,
      scrollWheelZoom: false,
      tap: false,
      layers: [cartoDB, pin],
    });
  }

  // Parse hash (two-levels)
  parseTabHash() {
    var result = {};

    var hash = location.hash.toLowerCase();
    if (!includes(hash, "#/tab/")) return false;

    // Force trailing slash on hash
    var lastHashChar = location.hash.substring(location.hash.length - 1, location.hash.length);
    if (lastHashChar !== "/") {
      location.hash = hash + "/";
    }

    var regex = /#\/tab\/([\w-]+)\/([\w-]+)?\/?/i;
    var matches = regex.exec(hash);
    var tab = get(matches, 1, false);

    result.hash = hash;
    result.tab = tab;
    result.anchor = get(matches, 2, false);
    result.href = "#/tab/" + tab + "/";

    return result;
  }

  // Horizontal tabs
  tabs() {
    // Switch to tab onload when a hash is present
    var switchTab = (e) => {
      // Stop default anchor hash
      if (e) e.preventDefault();

      // Only run on pages with tabs
      var $links = $("[data-tab-link]");
      var $content = $("[data-tab-content]");
      if (!$links.length || !$content.length) return;

      // No hash auto-selects the first
      if (!location.hash) {
        var initialHash = $links.first().attr("href");
        window.location.hash = initialHash;
        return;
      }

      // Make sure it's a #/tab/ hash
      var hash = this.parseTabHash();
      if (!hash) return;

      // On the current page
      var $link = $('a[data-tab-link][href="' + hash.href + '"]');
      if (!$link.length) return;

      // Open tab content
      $content.removeClass("open");
      $('[data-tab-content="' + hash.href + '"]').addClass("open");

      // Set tab to active state
      $("a[data-tab-link]").parent(".tab-row").removeClass("active");
      $link.parent(".tab-row").addClass("active");

      // Go to anchor reference if applicable
      if (hash.anchor) {
        var $anchor = $('[data-anchor="' + hash.anchor + '"]');
        if (!$anchor.length) return;

        var anchorOffset = $anchor.offset().top - 20;
        window.scrollTo(0, anchorOffset);
      } else {
        window.scrollTo(0, 0);
      }
    };

    // Fire on hashchange event
    $(window).on("hashchange", switchTab);

    // Click event changes hash
    $("[data-tab-link]").on("click", function (event) {
      if ($(this).hasClass("active")) event.preventDefault();
    });

    // Check for anchor links within the tab content
    var $tabContent = $("[data-tab-content]");
    if (!$tabContent.length) return;

    // Replace each anchor link in a tab content
    // area with #/tab/{tabHash}/{anchorHash}/ format
    $tabContent.each(function () {
      var $hashLinks = $('a[href^="#"]', this);
      if (!$hashLinks.length) return;

      var tabHash = $(this).data("tab-content");

      $hashLinks.each(function () {
        var anchor = $(this).attr("href").substring(1);
        if (!anchor) return;

        // Replace this links [href]
        var href = anchor == "top" ? tabHash : tabHash + anchor + "/";
        $(this).attr("href", href);

        // Replace the corresponding ID with [data-anchor]
        var selector = "#" + anchor;
        console.log("selector", selector);
        $(selector).attr("data-anchor", anchor).removeAttr("id");

        // Replace any link with a legacy [name] ID with [data-anchor]
        $('a[name="' + anchor + '"]')
          .attr("data-anchor", anchor)
          .removeAttr("id");
      });
    });

    // Fire initial hash event once anchors are ready
    switchTab();
  }

  // Get URL parameters
  getUrlParam(prop, defaultVal) {
    var params = {};
    var search = decodeURIComponent(window.location.href.slice(window.location.href.indexOf("?") + 1));
    var definitions = search.split("&");

    definitions.forEach(function (val, key) {
      var parts = val.split("=", 2);
      params[parts[0]] = parts[1];
    });

    if (prop) {
      return prop in params ? params[prop] : defaultVal || null;
    } else {
      return params;
    }
  }
}

new Coastal1_Theme();
